export enum Frequency {
  'millisecondly' = 'millisecondly',
  'thirty_minutely' = 'thirty_minutely',
  'fifteen_minutely' = 'fifteen_minutely',
  'ten_minutely' = 'ten_minutely',
  'five_minutely' = 'five_minutely',
  'hourly' = 'hourly',
  'daily' = 'daily',
  'weekly' = 'weekly',
  'monthly' = 'monthly',
  'quarterly' = 'quarterly',
  'half_yearly' = 'half_yearly',
  'yearly' = 'yearly',
}
